import { useLayoutEffect } from 'react';

const useHideZendeskWidget = () => {
  useLayoutEffect(() => {
    (window as any).zE?.('webWidget', 'hide');
  }, []);
};

export default useHideZendeskWidget;
